import { render } from "./B2bUserInformationDialog.vue?vue&type=template&id=c42fac86&lang=pug"
import script from "./B2bUserInformationDialog.vue?vue&type=script&lang=js"
export * from "./B2bUserInformationDialog.vue?vue&type=script&lang=js"

import "./B2bUserInformationDialog.vue?vue&type=style&index=0&id=c42fac86&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__